export default __webpack_public_path__ + "static/media/Love04.8c892e85.png";